import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";


function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I'm an early-career software developer working at a company.
              <br />
              <br />I’m improving my skills in 
              <i>
                <b className="purple"> C#, Python </b>
              </i>
              and
              <i>
                <b className="purple"> Javascript.</b>
              </i>
              <br /> I especially like working with 
              <i>
                <b className="purple"> ASP.NET Core, Entity Framework, Django, </b>
              </i>
              and 
              <i>
                <b className="purple"> React.js.</b>
              </i>
              <br />
              <br />
              I'm interested in
              <i>
                <b className="purple">
                  {" "}developing new web technologies, exploring current cybersecurity issues,
                </b>
              </i>
              and 
              <i>
                <b className="purple"> working on open-source projects.</b>
              </i>
              <br />
              <br />
              With my passion for programming and eagerness to learn, I aim to keep growing in my career.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>

          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/latifaltay"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://x.com/lat1faltay"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/latifaltay/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Home2;
